import React from 'react';
import styles from './paging.scss';

const Paging = () => <div className={styles.container} />;

export default Paging;



// WEBPACK FOOTER //
// ./src/containers/AdDetailsPage/AdDetailsPageMobile/SimilarAdsSection/SimilarAdsCarousel/Paging/index.tsx